import React from 'react';
import { SvgIcon } from '@mui/material';
import type { SvgIconProps } from '@mui/material';

const IamAgentLogo: React.FC<SvgIconProps> = (props) => (
  <SvgIcon viewBox="0 0 48 48" {...props}>
    <path
      d="M24 3.5 41 10v12.2c0 10.8-6.8 18.2-17 22.3C13.8 40.4 7 33 7 22.2V10l17-6.5Z"
      fill="currentColor"
      opacity="0.2"
    />
    <path
      d="M24 4.8 39.5 10.7v11.5c0 9.6-5.8 16.4-15.5 20.5C14.3 38.6 8.5 31.8 8.5 22.2V10.7L24 4.8Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinejoin="round"
    />
    <circle cx="24" cy="16" r="4.2" fill="currentColor" />
    <circle cx="16" cy="28.5" r="3" fill="currentColor" />
    <circle cx="32" cy="28.5" r="3" fill="currentColor" />
    <path
      d="m21.9 19.6-4.1 6.2m8.3-6.2 4.1 6.2M19 28.5h10"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
    />
    <path
      d="m34.8 8.2.8-2.7.8 2.7 2.7.8-2.7.8-.8 2.7-.8-2.7-2.7-.8 2.7-.8Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export default IamAgentLogo;
